module.exports = __webpack_public_path__ + "static/media/checkout.1d1bef3e.png";